<script setup lang="ts">
import { getNoticeList } from '@/service/api'
import { premessageGetList, pretodoitemGetList, pretodoitemGetListGet, pretodoitemsetReadAlready, pretodoitemSetToDoItemFinsh, setReaded, setReadedForNotice, setToDoStatus } from '@/service/api/accountCenter'
import { useTrackerStore } from '@/store'
import emitter from '@/utils/eventBus'
import NoticeList from '../common/NoticeList.vue'

const trackerStore = useTrackerStore()

const router = useRouter()

const drawerShow = ref(false)

function handleClose() {
  drawerShow.value = true
}

/** -----公告---START---- */
const noticeList = ref<User.Premessage.Notice.RecordsInfo[]>([])
async function getNoticeListFn() {
  try {
    const val = await getNoticeList({ backupField: {
      type: '',
      readStatus: 0,
    }, pageNo: 1, pageSize: 50 })
    if (val.code === 1000) {
      noticeList.value = val.data.records
    }
  }
  catch (error: any) {
    throw new Error(error)
  }
}
/** ----END ------- */
/** -----通知未读信息---START---- */
const allStatus = [
  { value: '', label: '消息类型' },
  {
    label: '系统消息',
    value: '系统消息',
  },
  {
    label: '续费消息',
    value: '续费消息',
  },
  {
    label: '订单消息',
    value: '订单消息',
  },
  {
    label: '财务消息',
    value: '财务消息',
  },
]
const typeSelect = ref('')

const notifyList: any = ref([])
async function premessageGetListFn() {
  try {
    const val = await premessageGetList({
      pageNo: 1,
      pageSize: 50,
      searchText: '',
      backupField: {
        type: typeSelect.value,
        readStatus: '0',
      },
    })
    if (val.code === 1000) {
      notifyList.value = val.data.records
    }
  }
  catch (error: any) {
    throw new Error(error)
  }
}
function selectChange(val: string) {
  typeSelect.value = val
  premessageGetListFn()
}
/** ----END ------ */

/** -----待办信息---START---- */
const waitList: any = ref([])
async function waitListGetListFn() {
  try {
    const res = await pretodoitemGetListGet()
    if (res.code === 1000) {
      waitList.value = res.data
    }
  }
  catch (error: any) {
    throw new Error(error)
  }
}
/** ----END ------ */

const currentTab = ref('站内通知')
async function handleRead(id: number | string, type: string, row?: any) {
  if (type === '站内通知') {
    const data = notifyList.value.find(i => i.id === id)
    if (data)
      data.readStatus = '1'
    if (id === '') {
      window.$dialog.info({
        title: '温馨提示',
        content: '请确认是否将全部信息标为已读？',
        positiveText: '确定',
        negativeText: '取消',
        onPositiveClick: async () => {
          trackerStore.reportBySpecialDirectives('Button', '站内通知全部已读', { public: true })
          const res = await setReaded({ id })
          if (res.code === 1000) {
            window.$message.success('设置成功')
            premessageGetListFn()
          }
        },
      })
    }
    else {
      const res = await setReaded({ id })
      if (res.code === 1000) {
        // window.$message.success('设置成功')
        premessageGetListFn()
        await router.push(`/accountCenter/notices/siteNotificationInfo/${id}`)
        drawerShow.value = false
        trackerStore.reportBySpecialDirectives('Page_Jumpto', id, { public: true })
      }
    }
  }
  if (type === '会员公告') {
    const data = noticeList.value.find(i => i.newid === id)
    if (data)
      data.newid = id
    if (id === '') {
      window.$dialog.info({
        title: '温馨提示',
        content: '请确认是否将全部信息标为已读？',
        positiveText: '确定',
        negativeText: '取消',
        onPositiveClick: async () => {
          trackerStore.reportBySpecialDirectives('Button', '会员公告全部已读', { public: true })
          const res = await setReadedForNotice({ id })
          if (res.code === 1000) {
            window.$message.success('设置成功')
            getNoticeListFn()
          }
        },
      })
    }
    else {
      const res = await setReadedForNotice({ id })
      if (res.code === 1000) {
        // window.$message.success('设置成功')
        getNoticeListFn()
        router.push(`/accountCenter/notices/memberAnnouncementInfo/${id}`)
        drawerShow.value = false
        trackerStore.reportBySpecialDirectives('Page_Jumpto', id, { public: true })
      }
    }
  }
  if (type === '待办事项') {
    const res = await pretodoitemsetReadAlready(id)
    if (res.code === 1000) {
      waitListGetListFn()
      // 跳转到待办事项详情
      await router.push(`/accountCenter/waitToDoInfo/${id}`)
      sessionStorage.setItem('waitToDoInfo', JSON.stringify(row))
      drawerShow.value = false
      trackerStore.reportBySpecialDirectives('Page_Jumpto', id, { public: true })
    }
  }
}
// 未读总数量
const massageCount = computed(() => {
  const noticeCount = noticeList.value.filter(i => i.newid === null).length
  const notifyCount = notifyList.value.filter(i => i.readStatus === '0').length
  return noticeCount + notifyCount + waitList.value.length
})

function linkMore() {
  if (currentTab.value === '站内通知') {
    router.push('/accountCenter/notices/siteNotification')
    drawerShow.value = false
  }
  if (currentTab.value === '会员公告') {
    router.push('/accountCenter/notices/memberAnnouncement')
    drawerShow.value = false
  }
  if (currentTab.value === '待办事项') {
    router.push('/accountCenter/waitToDo')
    drawerShow.value = false
  }
}

// 定义事件处理函数
function updateMessage(payload) {
  console.log('payload: ', payload)
  switch (payload) {
    case 'notify':
      premessageGetListFn() // 通知
      break
    case 'notice':
      getNoticeListFn() // 公告
      break
    case 'wait':
      waitListGetListFn()
      break
    default:
      break
  }
}

onMounted(() => {
  getNoticeListFn()
  premessageGetListFn()
  waitListGetListFn()
  // 监听 'custom-event' 事件
  emitter.on('custom-event', updateMessage)
})

onUnmounted(() => {
  // 组件销毁时注销事件监听，避免内存泄漏
  emitter.off('custom-event', updateMessage)
})
</script>

<template>
  <CommonWrapper v-track="{ type: 'Icon_Button', data: '通知铃铛', public: true }" class="!lt-md:hidden mx-12px" @click="handleClose">
    <n-badge :value="massageCount" :max="99" style="color: unset">
      <icon-park-outline-remind size="6" />
    </n-badge>
  </CommonWrapper>
  <div v-show="drawerShow" id="drawer-target" />
  <n-drawer
    v-model:show="drawerShow"
    width="500px"
    height="auto"
    placement="right"
    :trap-focus="false"
    :block-scroll="false"
    to="#drawer-target"
  >
    <n-drawer-content closable>
      <template #header>
        <div class="flex justify-between items-center">
          <span>消息通知</span>
          <div v-track="{ type: 'Page_Jumpto', public: true }" class="text-14px text-#888 hover:text-#1664FF cursor-pointer mr-10px" @click="linkMore">
            查看更多
          </div>
        </div>
      </template>
      <n-tabs v-model:value="currentTab" type="line" animated justify-content="space-evenly" @update:value="(e) => { trackerStore.reportBySpecialDirectives('Label', e, { public: true }) }">
        <n-tab-pane name="站内通知">
          <template #tab>
            <n-space class="w-130px" justify="center">
              站内通知
              <n-badge type="info" color="#1664FF" :value="notifyList.filter(i => i.readStatus === '0').length" :max="99" />
            </n-space>
          </template>
          <div class="flex justify-between items-center mb-12px">
            <n-select
              v-model:value="typeSelect"
              class="w-200px"
              filterable
              placeholder="消息类型"
              size="large"
              :options="allStatus"
              @update:value="selectChange"
            />
            <n-button v-if="notifyList.length > 0" text color="#1664FF" @click="handleRead('', '站内通知')">
              全部已读
            </n-button>
          </div>
          <NoticeList :list="notifyList" type="站内通知" @read="handleRead" />
        </n-tab-pane>
        <n-tab-pane name="会员公告">
          <template #tab>
            <n-space class="w-130px" justify="center">
              会员公告
              <n-badge type="info" color="#1664FF" :value="noticeList.filter(i => i.newid === null).length" :max="99" />
            </n-space>
          </template>
          <div v-if="noticeList.length > 0" class="flex justify-end mb-12px">
            <n-button text color="#1664FF" @click="handleRead('', '会员公告')">
              全部已读
            </n-button>
          </div>
          <NoticeList :list="noticeList" type="会员公告" @read="handleRead" />
        </n-tab-pane>
        <n-tab-pane name="待办事项">
          <template #tab>
            <n-space class="w-130px" justify="center">
              待办事项
              <n-badge type="info" color="#1664FF" :value="waitList.length" :max="99" />
            </n-space>
          </template>
          <!-- <div v-if="noticeList.length > 0" class="flex justify-end mb-12px">
            <n-button text color="#1664FF" @click="handleRead('', 2)">
              全部已读
            </n-button>
          </div> -->
          <NoticeList :list="waitList" type="待办事项" @read="handleRead" />
        </n-tab-pane>
      </n-tabs>
    </n-drawer-content>
  </n-drawer>
</template>

<style scoped lang="scss">
#drawer-target{
  position: fixed;
  top: 60px;
  right: 0;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 3;
}
</style>
